import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Descriptions, Table, Button, Tag, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getSalesOrderDetail } from '../../../services/api';

export default function OrderDetail() {
  const { soId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    getSalesOrderDetail(soId).then(res => setData(res.data)).catch(err => message.error(err.message));
  }, [soId]);

  if (!data) return <div>加载中...</div>;

  const itemColumns = [
    { title: 'SKU', dataIndex: 'skuId' },
    { title: '商品名称', dataIndex: 'name', ellipsis: true },
    { title: '数量', dataIndex: 'qty' },
    { title: '单价', dataIndex: 'price', render: (v) => `¥${Number(v).toLocaleString()}` },
    { title: '金额', dataIndex: 'amount', render: (v) => `¥${Number(v).toLocaleString()}` },
  ];

  const payColumns = [
    { title: '支付方式', dataIndex: 'payment' },
    { title: '金额', dataIndex: 'amount', render: (v) => `¥${Number(v).toLocaleString()}` },
    { title: '支付时间', dataIndex: 'payDate', render: (v) => v ? dayjs(v).format('YYYY-MM-DD HH:mm') : '-' },
  ];

  return (
    <div>
      <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} style={{ marginBottom: 16, padding: 0 }}>返回</Button>
      <Card title={`订单详情 - ${soId}`} style={{ marginBottom: 16 }}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="店铺">{data.order?.shopName}</Descriptions.Item>
          <Descriptions.Item label="平台">{data.order?.shopSite}</Descriptions.Item>
          <Descriptions.Item label="金额">¥{Number(data.order?.amount).toLocaleString()}</Descriptions.Item>
          <Descriptions.Item label="实付">¥{Number(data.order?.payAmount).toLocaleString()}</Descriptions.Item>
          <Descriptions.Item label="运费">¥{Number(data.order?.freight).toLocaleString()}</Descriptions.Item>
          <Descriptions.Item label="优惠金额">¥{Number(data.order?.freeAmount).toLocaleString()}</Descriptions.Item>
          <Descriptions.Item label="状态"><Tag>{data.order?.status}</Tag></Descriptions.Item>
          <Descriptions.Item label="下单时间">{data.order?.orderDate ? dayjs(data.order.orderDate).format('YYYY-MM-DD HH:mm') : '-'}</Descriptions.Item>
          <Descriptions.Item label="买家留言" span={2}>{data.order?.buyerMessage || '-'}</Descriptions.Item>
          <Descriptions.Item label="备注" span={2}>{data.order?.remark || '-'}</Descriptions.Item>
        </Descriptions>
      </Card>
      <Card title="商品明细" style={{ marginBottom: 16 }}>
        <Table dataSource={data.items} columns={itemColumns} rowKey="id" pagination={false} size="small" />
      </Card>
      <Card title="支付记录">
        <Table dataSource={data.pays} columns={payColumns} rowKey="id" pagination={false} size="small" />
      </Card>
    </div>
  );
}
